// React
import React, { useEffect, useState } from "react";
// Framework
import { ActivityComponent } from "activity";
import { useMounted } from "hooks";
import { usePortal } from "stack/core";
// Components
import PortalLayout from "../PortalLayout";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

export const PortalLoader2 = () => {
  // Framework
  const { apps } = usePortal();
  const { callWhenMounted } = useMounted();
  // State
  const [loader, setLoader] = useState(false);
  // Effect
  useEffect(() => {
    return apps.onChange(
      callWhenMounted(() => {
        setLoader(apps.current?.loader);
      }),
      true
    );
  }, [callWhenMounted, apps]);
  return loader;
};

const PortalLoader = ({ layoutPlugins, children }) => (
  <>
    <ActivityComponent />
    <PortalLayout layoutPlugins={layoutPlugins} />
    {children}
  </>
);

export default PortalLoader;
